import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import { hasValue } from '../../../../utils/NumberUtil'
import { EVENT_ACTION } from '../../../constants/PiezometryEventConstants'
import { getTitleCard, getYesOrNo } from '../EventFormUtils'
import { CENTRAL } from 'materiel/constants/MaterielConstants'
import { Card, CardContent, Grid, Typography } from '@mui/material'

const EventCentralCard = ({
    central = {},
    formActions = [],
    disabled = {},
    lastReplacementDate = '',
    setFormAction = () => {},
    getBooleanChoiceWithAction = () => {},
    hasPowerSupply = true,
}) => {
    const {
        centralTypes,
        powerSupplyTypes,
    } = useSelector(store => ({
        centralTypes: store.CentralReducer.centralTypes,
        powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
    }), shallowEqual)
    const powerSupplyType = powerSupplyTypes.find(t => t.id === central.powerSupplyType)
    return (
        <Card>
            {getTitleCard(i18n.central, CENTRAL, central, centralTypes)}
            <CardContent>
                {
                    hasPowerSupply && (
                        <>
                            <Grid container alignItems={'center'}>
                                <Grid size={8}>
                                    <NumberField
                                        value={(formActions.find(a => a.managementRule === EVENT_ACTION.MESURE_TENSION_CENTRALE && a.materielId === central.id) || {}).value}
                                        title={i18n.centralVoltage}
                                        floatValue
                                        onChange={v => setFormAction(EVENT_ACTION.MESURE_TENSION_CENTRALE, v, central.id, hasValue(v))}
                                        {...disabled}
                                    />
                                </Grid>
                                <Grid offset={1} size={3}>
                                    <Checkbox
                                        label={i18n.replacement}
                                        checked={formActions.find(a => a.managementRule === EVENT_ACTION.REMPLACEMENT_PILES_CENTRALE && a.materielId === central.id)}
                                        onChange={v => setFormAction(EVENT_ACTION.REMPLACEMENT_PILES_CENTRALE, null, central.id, v)}
                                        active={disabled.active}
                                        disabled={powerSupplyType?.isNotReplaceable || disabled.disabled}
                                    />
                                </Grid>
                            </Grid>
                            <Typography variant='h6'>{`${i18n.lastReplacement} : ${lastReplacementDate}`}</Typography>
                        </>
                    )
                }
                <Grid container>
                    <Grid size={8}>
                        <table>
                            {getYesOrNo()}
                            {getBooleanChoiceWithAction(i18n.resettingStations, EVENT_ACTION.REINITIALISATION_STATION, central.id, disabled)}
                            {getBooleanChoiceWithAction(i18n.firmwareUpdate, EVENT_ACTION.FIRMWARE_MIS_A_JOUR, central.id, disabled)}
                        </table>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

EventCentralCard.propTypes = {
    central: PropTypes.object,
    formActions: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.object,
    lastReplacementDate: PropTypes.string,
    setFormAction: PropTypes.func,
    getBooleanChoiceWithAction: PropTypes.func,
    hasPowerSupply: PropTypes.bool,
}

export default EventCentralCard